import React, { useMemo } from 'react';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import { QUILL_FORMATS, QUILL_MODULES } from '../../utils/richText';

const QUILL_DARK_STYLES = `
  .rich-text-editor .ql-toolbar.ql-snow {
    border: none;
    border-bottom: 1px solid rgba(75, 85, 99, 0.5);
    background: rgba(17, 24, 39, 0.9);
  }
  .rich-text-editor .ql-container.ql-snow {
    border: none;
    font-size: 15px;
  }
  .rich-text-editor .ql-editor {
    color: #F9FAFB;
  }
  .rich-text-editor .ql-editor.ql-blank::before {
    color: #6B7280;
    font-style: normal;
  }
  .rich-text-editor .ql-stroke { stroke: #9CA3AF; }
  .rich-text-editor .ql-fill { fill: #9CA3AF; }
  .rich-text-editor .ql-picker { color: #D1D5DB; }
  .rich-text-editor .ql-picker-options { background: #111827; color: #F9FAFB; }
  .rich-text-editor .ql-toolbar button:hover .ql-stroke,
  .rich-text-editor .ql-toolbar button.ql-active .ql-stroke { stroke: #C084FC; }
  .rich-text-editor .ql-toolbar button:hover .ql-fill,
  .rich-text-editor .ql-toolbar button.ql-active .ql-fill { fill: #C084FC; }
`;

export default function RichTextEditor({
  value,
  onChange,
  placeholder = '',
  readOnly = false,
  className = '',
  minHeight = 180,
}) {
  const modules = useMemo(() => QUILL_MODULES, []);

  return (
    <>
      <style>{QUILL_DARK_STYLES}</style>
      <div className={`rich-text-editor rounded-xl border border-gray-600/40 overflow-hidden bg-gray-900/60 ${className}`}>
        <ReactQuill
          theme="snow"
          value={value || ''}
          onChange={onChange}
          modules={modules}
          formats={QUILL_FORMATS}
          readOnly={readOnly}
          placeholder={placeholder}
          style={{ minHeight }}
        />
      </div>
    </>
  );
}
